(() => {
  const normalizeSize = (value) => {
    const normalized = String(value || '').trim().toUpperCase();
    return normalized.match(/^(XXS|XS|S|M|L|XL|XXL|XXXL)\b/)?.[1] || normalized;
  };

  const bindSizeGuide = (root = document) => {
    const drawer = root.querySelector('[data-sunoire-size-guide-drawer]') || document.querySelector('[data-sunoire-size-guide-drawer]');
    const overlay = root.querySelector('[data-sunoire-size-guide-overlay]') || document.querySelector('[data-sunoire-size-guide-overlay]');

    if (!drawer || drawer.dataset.bound === 'true') return;
    drawer.dataset.bound = 'true';

    const closeButtons = Array.from(document.querySelectorAll('[data-sunoire-size-guide-close]'));
    const body = drawer.querySelector('.sunoire-size-guide-drawer__body');
    const mobileGuide = drawer.querySelector('.atelier2__sg-mobile');

    if (body?.querySelector('.atelier2__fit-studio')) {
      body.classList.add('has-selected-size-guide');
    }

    // Polish the measurement chart: label each row's size, split cm / in for a
    // unit toggle, and add a "Body measurements" header row with the toggle.
    // sunoire-sg-fit-2026-multi: loop every .atelier2__sg-section (a two-piece
    // set like a blazer+trousers product renders two independent sections,
    // each needs its own toggle — previously only the first ever got one).
    const enhanceChart = () => {
      const sections = Array.from(drawer.querySelectorAll('.atelier2__sg-section'));
      sections.forEach(enhanceOneSection);
    };

    const enhanceOneSection = (section) => {
      const table = section.querySelector('.atelier2__sg-table') || section.querySelector('table');
      if (!section || !table || section.dataset.sgEnhanced === 'true') return;
      section.dataset.sgEnhanced = 'true';

      const rows = Array.from(table.rows);
      // Matches single values ("80 cm / 31.5 in") and ranges ("86-90 cm / 33.9-35.4 in")
      const unitRe = /^\s*([\d.,]+(?:\s*[–—-]\s*[\d.,]+)?\s*cm)\s*\/\s*([\d.,]+(?:\s*[–—-]\s*[\d.,]+)?\s*(?:in|inch|inches|"))\s*$/i;
      let converted = 0;

      rows.forEach((row, rowIndex) => {
        if (rowIndex === 0) return; // header
        if (row.cells[0]) row.dataset.sgSize = normalizeSize(row.cells[0].textContent);
        Array.from(row.cells).forEach((cell, cellIndex) => {
          if (cellIndex === 0) return;
          const match = cell.textContent.match(unitRe);
          if (!match) return;
          // sunoire-sg-fit-2026: numbers only; unit lives in the toggle + chart label
          const cmVal = match[1].replace(/s*cm$/i, '').trim();
          const inVal = match[2].replace(/s*(?:in|inch|inches|")$/i, '').trim();
          cell.innerHTML = `<span class="sg-u sg-u-cm">${cmVal}</span><span class="sg-u sg-u-in">${inVal}</span>`;
          converted += 1;
        });
      });

      const head = document.createElement('div');
      head.className = 'sg-chart-head';
      const label = document.createElement('span');
      label.className = 'sg-chart-head__label';
      // sunoire-sg-fit-2026-uk: default view is inches (UK-first shopper base),
      // cm stays one tap away via the same toggle rather than being removed.
      // 2026-08-09: label volgt het tabel-type. Leverancierstabellen met
      // kledingstukmaten (caption "Flat garment measurements") kregen hier
      // ten onrechte "Body measurements" boven zich - een platte vestbreedte
      // van 50 cm is geen lichaamsmaat.
      const chartCaption = table.querySelector('caption');
      const isGarment = chartCaption && /garment/i.test(chartCaption.textContent);
      const labelBasis = isGarment ? 'Garment measurements' : 'Body measurements';
      label.textContent = converted > 0 ? labelBasis + ' (in)' : labelBasis;
      head.appendChild(label);

      if (converted > 0) {
        table.classList.add('show-in');
        const toggle = document.createElement('div');
        toggle.className = 'sg-unit-toggle';
        toggle.setAttribute('role', 'group');
        toggle.setAttribute('aria-label', 'Measurement units');
        toggle.innerHTML = '<button type="button" data-unit="cm" aria-pressed="false">cm</button>'
          + '<button type="button" data-unit="in" class="is-active" aria-pressed="true">in</button>';
        toggle.addEventListener('click', (event) => {
          const btn = event.target.closest('button[data-unit]');
          if (!btn) return;
          const showIn = btn.dataset.unit === 'in';
          table.classList.toggle('show-in', showIn);
          label.textContent = showIn ? 'Body measurements (in)' : 'Body measurements (cm)';
          Array.from(toggle.querySelectorAll('button')).forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
        head.appendChild(toggle);
      }

      (table.parentNode || section).insertBefore(head, table);
    };

    try {
      enhanceChart();
    } catch (error) {
      /* chart polish is non-essential — never let it break the size guide button */
    }

    let activateMobileSize = () => false;

    if (mobileGuide && mobileGuide.dataset.sunoireMobileGuideBound !== 'true') {
      mobileGuide.dataset.sunoireMobileGuideBound = 'true';
      const cards = Array.from(mobileGuide.querySelectorAll(':scope > .atelier2__sg-card'));

      if (cards.length > 1) {
        cards.forEach((card) => {
          card.querySelectorAll('h4').forEach((heading) => {
            if (heading.textContent.trim().toLowerCase() === 'recommended body') {
              heading.textContent = 'Recommended body measurements';
            }
          });
        });

        let nav = mobileGuide.querySelector(':scope > .atelier2__fit-nav');

        if (!nav) {
          nav = document.createElement('div');
          nav.className = 'atelier2__fit-nav';
          nav.setAttribute('role', 'tablist');
          nav.setAttribute('aria-label', 'Select size');
          mobileGuide.insertBefore(nav, cards[0]);
        }

        const activateMobileCard = (index) => {
          const safeIndex = Math.max(0, Math.min(index, cards.length - 1));
          Array.from(nav.querySelectorAll('[data-sunoire-mobile-size-card]')).forEach((button, buttonIndex) => {
            const active = buttonIndex === safeIndex;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          cards.forEach((card, cardIndex) => {
            card.hidden = cardIndex !== safeIndex;
            card.classList.toggle('is-active', cardIndex === safeIndex);
          });
        };

        activateMobileSize = (size) => {
          const normalizedSize = normalizeSize(size);
          const matchingIndex = cards.findIndex((card) => normalizeSize(card.querySelector('.atelier2__sg-card-size')?.textContent) === normalizedSize);

          if (matchingIndex < 0) return false;
          activateMobileCard(matchingIndex);
          return true;
        };

        if (!nav.querySelector('[data-sunoire-mobile-size-card]')) {
          cards.forEach((card, index) => {
            const sizeLabel = card.querySelector('.atelier2__sg-card-size')?.textContent?.trim() || String(index + 1);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `atelier2__fit-size${index === 0 ? ' is-active' : ''}`;
            button.dataset.sunoireMobileSizeCard = String(index);
            button.setAttribute('role', 'tab');
            button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
            button.textContent = sizeLabel;
            button.addEventListener('click', () => activateMobileCard(index));
            nav.appendChild(button);
          });
        }

        activateMobileCard(0);
      }
    }

    const getRawSelectedSize = (trigger) => {
      const productInfo = trigger?.closest('product-info') || document.querySelector('product-info');
      const selectors = productInfo?.querySelector('variant-selects') || productInfo;

      if (!selectors) return '';

      const sizeFieldset = Array.from(selectors.querySelectorAll('fieldset')).find((fieldset) => {
        return fieldset.querySelector('legend')?.textContent?.trim().toLowerCase().includes('size');
      });
      const checkedSizeInput = sizeFieldset?.querySelector('input[type="radio"]:checked')
        || Array.from(selectors.querySelectorAll('input[type="radio"]:checked')).find((input) => {
          return input.name?.trim().toLowerCase().includes('size');
        });

      if (checkedSizeInput) return checkedSizeInput.value.trim();

      const sizeSelect = Array.from(selectors.querySelectorAll('select')).find((select) => {
        const label = selectors.querySelector(`label[for="${CSS.escape(select.id)}"]`)?.textContent || '';
        return `${select.name || ''} ${label}`.toLowerCase().includes('size');
      });

      return sizeSelect ? sizeSelect.value.trim() : '';
    };

    const getSelectedProductSize = (trigger) => normalizeSize(getRawSelectedSize(trigger));

    // Shoe charts are an EU/UK/US grid — highlight the row matching the chosen shoe size.
    const firstNumber = (value) => (String(value).match(/\d+(?:\.\d+)?/) || [''])[0];

    const highlightShoeRow = (rawSize) => {
      const grid = drawer.querySelector('.s-sg__grid');
      if (!grid) return false;

      const target = firstNumber(rawSize);
      const rows = Array.from(grid.querySelectorAll('.s-sg__row')).filter((row) => !row.classList.contains('s-sg__head'));
      let matched = false;

      rows.forEach((row) => {
        const cell = row.querySelector('span');
        const active = !!target && firstNumber(cell ? cell.textContent : '') === target;
        row.classList.toggle('is-active-size', active);
        if (active) matched = true;
      });

      return matched;
    };

    const syncSelectedSize = (trigger) => {
      const raw = getRawSelectedSize(trigger);
      const normalized = normalizeSize(raw);
      const apparelFallback = drawer.querySelector('[data-a2-fit-size]')?.dataset.a2FitSize
        || drawer.querySelector('.atelier2__sg-table tr:nth-child(2) td, .sunoire-size-guide-drawer__body table tr:nth-child(2) td')?.textContent;
      const shoeFallback = drawer.querySelector('.s-sg__grid .s-sg__row:not(.s-sg__head) span')?.textContent;

      activateFitSize(normalized || apparelFallback || '');
      activateMobileSize(normalized || apparelFallback || '');
      highlightShoeRow(raw || shoeFallback || '');
    };

    const openDrawer = (trigger) => {
      try {
        syncSelectedSize(trigger);
      } catch (error) {
        /* size sync is non-essential — always open the drawer */
      }

      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.documentElement.classList.add('sunoire-modal-open');
        drawer.querySelector('[data-sunoire-size-guide-close]')?.focus();
      });
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('sunoire-modal-open');
      window.setTimeout(() => {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 220);
    };

    const rowSize = (row) => row.dataset.sgSize || (row.cells[0] ? normalizeSize(row.cells[0].textContent) : '');

    const highlightChartRow = (normalizedSize) => {
      const tables = Array.from(drawer.querySelectorAll('.atelier2__sg-table, .sunoire-size-guide-drawer__body table'));
      let matched = false;

      tables.forEach((table) => {
        Array.from(table.rows).forEach((row, rowIndex) => {
          if (rowIndex === 0) return; // header row
          const firstCell = row.cells[0];
          const active = !!firstCell && rowSize(row) === normalizedSize;
          row.classList.toggle('is-active-size', active);

          if (firstCell) {
            let badge = firstCell.querySelector('.sg-your-size');
            if (active && !badge) {
              badge = document.createElement('span');
              badge.className = 'sg-your-size';
              badge.textContent = 'Your size';
              firstCell.appendChild(badge);
            } else if (!active && badge) {
              badge.remove();
            }
          }

          if (active) matched = true;
        });
      });

      return matched;
    };

    const activateFitSize = (size) => {
      const normalizedSize = normalizeSize(size);
      const fitButtons = Array.from(drawer.querySelectorAll('[data-a2-fit-size]'));
      const fitPanels = Array.from(drawer.querySelectorAll('[data-a2-fit-panel]'));

      fitButtons.forEach((button) => {
        const active = normalizeSize(button.dataset.a2FitSize) === normalizedSize;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      fitPanels.forEach((panel) => {
        const active = normalizeSize(panel.dataset.a2FitPanel) === normalizedSize;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      const highlighted = highlightChartRow(normalizedSize);

      return fitButtons.some((button) => normalizeSize(button.dataset.a2FitSize) === normalizedSize) || highlighted;
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-sunoire-size-guide-open]');
      if (!openButton) return;
      openDrawer(openButton);
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('click', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.target.closest('[data-sunoire-size-guide-drawer]')) return;
      if (event.target.closest('[data-sunoire-size-guide-open]')) return;
      closeDrawer();
    });

    // Keep the highlighted chart row in sync with the size chosen on the product page
    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects, product-info')) return;
      syncSelectedSize(event.target);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  };

  document.addEventListener('DOMContentLoaded', () => bindSizeGuide());
  document.addEventListener('shopify:section:load', (event) => bindSizeGuide(event.target));
})();
